import * as React from "react";

export const PermissionContext = React.createContext<Set<string>>(null);
